import { render, staticRenderFns } from "./tablePlanZY.vue?vue&type=template&id=2a14f442&scoped=true"
import script from "./tablePlanZY.vue?vue&type=script&lang=js"
export * from "./tablePlanZY.vue?vue&type=script&lang=js"
import style0 from "./tablePlanZY.vue?vue&type=style&index=0&id=2a14f442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a14f442",
  null
  
)

export default component.exports